var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef } from "react";
import { useDebounce } from "@/06-shared/lib/useDebounce";
import { saveDocumentTitle } from "@/06-shared/api";
import { useNotifyError } from "@/06-shared/lib/useNotifyError";
export const useAutoSaveTitle = ({ title, documentId, debounceMs = 1000, enabled = true, }) => {
    const debouncedTitle = useDebounce(title, debounceMs);
    const savedTitleRef = useRef(null);
    const documentIdRef = useRef(documentId);
    const showError = useNotifyError();
    useEffect(() => {
        if (documentIdRef.current !== documentId) {
            documentIdRef.current = documentId;
            savedTitleRef.current = null;
        }
        if (!enabled) {
            savedTitleRef.current = null;
            return;
        }
        if (savedTitleRef.current === null) {
            savedTitleRef.current = title;
            return;
        }
        if (debouncedTitle === savedTitleRef.current) {
            return;
        }
        const saveTitle = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield saveDocumentTitle({
                    title: debouncedTitle,
                    docId: documentId,
                });
                savedTitleRef.current = debouncedTitle;
            }
            catch (error) {
                showError(error);
            }
        });
        saveTitle();
    }, [debouncedTitle, documentId, enabled]);
};
